/* =============================================================
   TABS — Cart progress bar (Rebuy cart drawer injection)

   IG used to populate <ig-shipping-progress-container> client-side.
   IG was removed, so we inject our own progress bar at the top of
   Rebuy's SmartCart drawer (Rebuy.SmartCart.show() opens it).

   The native <dialog id="miniCart"> in theme-mini-cart.liquid is
   dead code — theme-mini-cart.js openCart() short-circuits to
   Rebuy and never opens the native dialog. We ignore it.
   ============================================================= */
(function () {
    "use strict";

    var CONFIG = {
        headline: "Keep stacking. Save more.",
        anchorAmount: 60,
        itemTiers: [
            { items: 2, percent: 7 },
            { items: 3, percent: 16 }
        ]
    };

    var HOST_ID = "tabsProgressBarHost";
    var rendering = false, lastTotal = -1, lastItems = -1;

    function fetchCart() {
        return fetch("/cart.js", {
            credentials: "same-origin",
            headers: { "Accept": "application/json" }
        })
            .then(function (r) { return r.ok ? r.json() : null; })
            .catch(function () { return null; });
    }

    function buildMarkup(cart) {
        var total = cart.total_price / 100;
        var itemCount = cart.item_count;
        var fillPercent = Math.min((total / CONFIG.anchorAmount) * 100, 100);

        var helperParts = [];
        var remaining = CONFIG.anchorAmount - total;
        if (remaining > 0) {
            helperParts.push("Add $" + remaining.toFixed(2) + " more for Free Shipping");
        } else {
            helperParts.push("Free Shipping unlocked");
        }

        var nextTier = null, activeTier = null;
        CONFIG.itemTiers.forEach(function (t) {
            if (itemCount >= t.items) activeTier = t;
            else if (!nextTier) nextTier = t;
        });
        if (nextTier) {
            var need = nextTier.items - itemCount;
            helperParts.push("Add " + need + " more item" + (need === 1 ? "" : "s") +
                " for " + nextTier.percent + "% OFF!");
        } else if (activeTier) {
            helperParts.push(activeTier.percent + "% OFF unlocked!");
        }

        var maxTierItems = Math.max.apply(null, CONFIG.itemTiers.map(function (t) { return t.items; }));
        var tierStarsHtml = CONFIG.itemTiers.map(function (t) {
            var pos = Math.min((t.items / maxTierItems) * 100, 95);
            var reached = itemCount >= t.items;
            return '<span class="tabsProgressBarStar' + (reached ? " tabsProgressBarStar--reached" : "") +
                '" style="left:' + pos + '%" aria-hidden="true">★</span>';
        }).join("");

        var fsReached = total >= CONFIG.anchorAmount;
        var anchorStar = '<span class="tabsProgressBarStar' + (fsReached ? " tabsProgressBarStar--reached" : "") +
            '" style="left:100%" aria-hidden="true">★</span>';

        var helperClass = "tabsProgressBarHelper" + (fillPercent >= 100 && !nextTier ? " tabsProgressBarHelper--unlocked" : "");

        return (
            '<div class="tabsProgressBar" role="region" aria-label="Cart progress">' +
                '<div class="tabsProgressBarHeadline">' + CONFIG.headline + '</div>' +
                '<div class="tabsProgressBarTrack">' +
                    '<div class="tabsProgressBarFill" style="width:' + fillPercent + '%"></div>' +
                    tierStarsHtml +
                    anchorStar +
                '</div>' +
                '<div class="' + helperClass + '">' + helperParts.join(" • ") + '</div>' +
            '</div>'
        );
    }

    /* Find Rebuy's cart drawer body — multiple fallbacks for resilience. */
    function findInjectionTarget() {
        var selectors = [
            ".rebuy-cart__flyout-body",
            ".rebuy-cart__flyout-content",
            ".rebuy-cart__flyout-items",
            "[class*='rebuy-cart__flyout-body']",
            "[class*='rebuy-cart__flyout-content']",
            "[class*='rebuy-cart__flyout-items']",
            ".rebuy-cart__flyout",
            "[class*='rebuy-cart__flyout']:not([class*='header']):not([class*='footer']):not([class*='checkout'])",
            "[data-rebuy-component='cart']",
            "[data-rebuy-component*='cart']"
        ];
        for (var i = 0; i < selectors.length; i++) {
            var el = document.querySelector(selectors[i]);
            if (el && el.offsetParent !== null) return el;
        }
        return null;
    }

    function getOrCreateHost() {
        var existing = document.getElementById(HOST_ID);
        var target = findInjectionTarget();
        if (!target) return null;
        if (existing && existing.parentElement === target && existing === target.firstElementChild) {
            return existing;
        }
        if (existing && existing.parentElement) {
            existing.parentElement.removeChild(existing);
        }
        var host = document.createElement("div");
        host.id = HOST_ID;
        target.insertBefore(host, target.firstChild);
        return host;
    }

    function render(cart) {
        if (!cart) return;
        var host = getOrCreateHost();
        if (!host) return;
        if (cart.total_price === lastTotal &&
            cart.item_count === lastItems &&
            host.innerHTML &&
            host.querySelector(".tabsProgressBar")) {
            return;
        }
        lastTotal = cart.total_price;
        lastItems = cart.item_count;
        host.innerHTML = buildMarkup(cart);
    }

    function update() {
        if (rendering) return;
        rendering = true;
        fetchCart().then(function (cart) {
            rendering = false;
            render(cart);
        });
    }

    function hookFetch() {
        if (window.__tabsCartFetchHooked) return;
        window.__tabsCartFetchHooked = true;
        var origFetch = window.fetch;
        window.fetch = function () {
            var url = arguments[0];
            if (url && typeof url === "object" && url.url) url = url.url;
            var result = origFetch.apply(this, arguments);
            if (typeof url === "string" && /\/cart\/(add|update|change|clear)(\.js)?/.test(url)) {
                result.then(function () { setTimeout(update, 100); }, function () {});
            }
            return result;
        };
        var XOpen = XMLHttpRequest.prototype.open;
        XMLHttpRequest.prototype.open = function (m, u) { this.__tabsCartUrl = u; return XOpen.apply(this, arguments); };
        var XSend = XMLHttpRequest.prototype.send;
        XMLHttpRequest.prototype.send = function () {
            if (this.__tabsCartUrl && /\/cart\/(add|update|change|clear)(\.js)?/.test(this.__tabsCartUrl)) {
                this.addEventListener("loadend", function () { setTimeout(update, 100); });
            }
            return XSend.apply(this, arguments);
        };
    }

    function watchForRebuyCart() {
        var ticking = false;
        new MutationObserver(function (muts) {
            var rebuyChange = muts.some(function (m) {
                return Array.from(m.addedNodes).some(function (n) {
                    if (n.nodeType !== 1) return false;
                    var cls = (n.className || "").toString();
                    return /rebuy/i.test(cls) || /rebuy/i.test(n.id || "");
                });
            });
            if (!rebuyChange) return;
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(function () {
                update();
                ticking = false;
            });
        }).observe(document.body, { childList: true, subtree: true });
    }

    function init() {
        hookFetch();
        watchForRebuyCart();
        update();
        [
            "rebuy:cart.show", "rebuy:cart.update", "rebuy:smartcart.ready", "rebuy:widget.render",
            "cart:updated", "cart:refresh"
        ].forEach(function (evt) {
            document.addEventListener(evt, function () { setTimeout(update, 200); });
            window.addEventListener(evt, function () { setTimeout(update, 200); });
        });
        setTimeout(update, 1000);
        setTimeout(update, 3000);
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", init);
    } else {
        init();
    }
})();
